import type { Dispatch, SetStateAction } from "react";

export type PendingFile = { key: string; file: File; storageId?: string; error?: string };
export type ComposerDraft = { draft: string; files: PendingFile[]; sending: boolean; error: string | null; scheduleOpen: boolean; scheduledFor: string };
const empty: ComposerDraft = { draft: "", files: [], sending: false, error: null, scheduleOpen: false, scheduledFor: "" };

// Memory only. The provider belongs to one unlocked workspace session, so no
// message text or file bytes are persisted on a shared phone or across sign-in.
export function createComposerDraftStore() {
  const drafts = new Map<string, ComposerDraft>();
  const listeners = new Set<() => void>();
  const get = (key: string) => drafts.get(key) ?? empty;
  return {
    get,
    subscribe: (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; },
    set<K extends keyof ComposerDraft>(key: string, field: K, action: SetStateAction<ComposerDraft[K]>) {
      const previous = get(key);
      const value = typeof action === "function" ? (action as (value: ComposerDraft[K]) => ComposerDraft[K])(previous[field]) : action;
      drafts.set(key, { ...previous, [field]: value });
      for (const listener of listeners) listener();
    }
  };
}
export type DraftSetter<K extends keyof ComposerDraft> = Dispatch<SetStateAction<ComposerDraft[K]>>;
